import { Button, 
         DialogContent, 
         TextField
       }                          from "@mui/material"
import React, 
       { useState, 
         useCallback, 
         useEffect 
       }                          from "react"
import { BglDialog, 
         BglDialogTitle, 
         BglDialogActions 
       }                          from "components/dialog/BglDialogStyles"
import { APIData }                from "types/cms/frontendTypes"

interface SurveyTemplateEditNameDialogProps {
  open : boolean
  onClose : () => void
  template : APIData<'api::survey-template.survey-template'>
  onTemplateChange : (updatedTemplate: APIData<'api::survey-template.survey-template'>) => void
}

export const SurveyTemplateEditNameDialog: React.FC<SurveyTemplateEditNameDialogProps> = ({
  open,
  onClose,
  template,
  onTemplateChange,
}) => {
  const [editNameValue, setEditNameValue] = useState('')

  // Initialize edit name value when dialog opens or template changes
  useEffect(() => {
    if (open) {
      setEditNameValue(template.label)
    }
  }, [open, template])

  const handleClose = useCallback(() => {
    onClose()
    setEditNameValue('')
  }, [onClose])

  const handleSaveName = useCallback(() => {
    if (!editNameValue.trim()) return
    
    // Validate that the name has actually changed
    if (editNameValue.trim() === template.label) {
      handleClose()
      return
    }
    
    const updatedTemplate = {
      ...template,
      label: editNameValue.trim(),
    }
    
    onTemplateChange(updatedTemplate)
    handleClose()
  }, [template, editNameValue, handleClose, onTemplateChange])

  return (
    <BglDialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <BglDialogTitle
        title="Edit Template Name"
        onClose={handleClose}
      />
      <DialogContent>
        <TextField
          label="Template Name"
          fullWidth
          value={editNameValue}
          onChange={(e) => setEditNameValue(e.target.value)}
          autoFocus
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <BglDialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button
          onClick={handleSaveName}
          variant="contained"
          disabled={!editNameValue.trim()}
        >
          Update Name
        </Button>
      </BglDialogActions>
    </BglDialog>
  )
}
